import React from 'react';
import PropTypes from 'prop-types';

import upArrow from '../images/up_arrow.svg';
import downArrow from '../images/down_arrow.svg';
import checkmark from '../images/checkmark.svg';

import VstDropdown from './VstDropdown';

const path = 'https://bookshelf.vitalsource.com/img/locales/';
const languages = [
  { short: 'en', long: 'English', img: 'en.png' },
  { short: 'ar', long: 'العربية', img: 'ar.png' },
  { short: 'bg', long: 'Български', img: 'bg.png' },
  { short: 'ca', long: 'Català', img: 'ca.png' },
  { short: 'cs', long: 'čeština', img: 'cs.png' },
  { short: 'cy', long: 'Cymraeg', img: 'cy.png' },
  { short: 'da', long: 'Dansk', img: 'da.png' },
  { short: 'de', long: 'Deutsch', img: 'de.png' },
  { short: 'el', long: 'ελληνικά', img: 'el.png' },
  { short: 'en_GB', long: 'English (UK)', img: 'en-GB.png' },
  { short: 'es', long: 'Español', img: 'es.png' },
  { short: 'es_MX', long: 'Español - México', img: 'es-MX.png' },
  { short: 'fi', long: 'Suomi', img: 'fi.png' },
  { short: 'fil', long: 'Tagalog', img: 'fil.png' },
  { short: 'fr_CA', long: 'Français - Canada', img: 'fr-CA.png' },
  { short: 'fr', long: 'Français', img: 'fr.png' },
  { short: 'gd', long: 'Gaeilge', img: 'gd.png' },
  { short: 'he', long: 'עברית', img: 'he.png' },
  { short: 'hi', long: 'हिंदी', img: 'hi.png' },
  { short: 'is', long: 'Íslenska', img: 'is.png' },
  { short: 'it', long: 'Italiano', img: 'it.png' },
  { short: 'ja', long: '日本語', img: 'ja.png' },
  { short: 'ko', long: '한국어', img: 'ko.png' },
  { short: 'nl', long: 'Nederlands', img: 'nl.png' },
  { short: 'no', long: 'Norsk', img: 'no.png' },
  { short: 'pl', long: 'Polski', img: 'pl.png' },
  { short: 'pt_BR', long: 'Português do Brasil', img: 'pt-BR.png' },
  { short: 'pt', long: 'Português', img: 'pt.png' },
  { short: 'ro', long: 'Română', img: 'ro.png' },
  { short: 'ru', long: 'Pусский', img: 'ru.png' },
  { short: 'sv', long: 'Svensk', img: 'sv.png' },
  { short: 'th', long: 'ภาษาไทย', img: 'th.png' },
  { short: 'tr', long: 'Türk', img: 'tr.png' },
  { short: 'vi', long: 'Tiếng Việt', img: 'vi.png' },
  { short: 'zh_CN', long: '中文简体', img: 'zh-CN.png' },
  { short: 'zh_TW', long: '繁體中文', img: 'zh-TW.png' },
];

export default class VstLocales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.selected,
    };
  }

  render() {
    return (
      <VstDropdown
        className={`vst-locales ${this.props.menuName}`}
        horizontal={this.props.horizontal}
        vertical={this.props.vertical}
        target={this.renderTarget()}
        height={this.props.height}
        customX={this.props.customX}
        customY={this.props.customY}
        isMobile={this.props.isMobile}
        headerTitle={this.props.headerTitle}
        showBackBtn={this.props.showBackBtn}
        showApplyBtn={this.props.showApplyBtn}
        headerBackButton={this.props.headerBackButton}
        scrollable
      >
        {this.renderLanguages()}
      </VstDropdown>
    );
  }

  onClick(selected) {
    this.setState({ selected });
    if (this.props.onChange) {
      this.props.onChange(selected);
    }
  }

  renderTarget() {
    const language = languages.find(l => l.short === this.state.selected);
    return (
      <button key="vst-locale-target" className="vst-locales-button">
        <span className="vst-locales-target-label">{this.props.label}</span>

        <span className="vst-language">
          {this.props.customText || language.long}
        </span>

        <img role="presentation" src={`${path}/${language.img}`} />

        {this.props.vertical === 'top' ? upArrow() : downArrow()}
      </button>
    );
  }

  renderLanguages() {
    return languages.map(language => (
      <VstDropdown.Item
        key={`locales-${language.short}`}
        className={`vst-language ${this.props.className}`}
        selected={this.state.selected === language.short}
        onClick={() => this.onClick(language.short)}
        style={{
          backgroundImage: `url('${path}/${language.img}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '10px',
          paddingLeft: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {language.long}
        {this.state.selected === language.short && checkmark()}
      </VstDropdown.Item>
    ));
  }
}

VstLocales.propTypes = {
  selected: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  menuName: PropTypes.string,
  headerTitle: PropTypes.string,
  customX: PropTypes.number,
  customY: PropTypes.number,
  onChange: PropTypes.func,
  horizontal: PropTypes.oneOf(['left', 'right']),
  vertical: PropTypes.oneOf(['bottom', 'top']),
  height: PropTypes.string,
  headerBackButton: PropTypes.string,
  isMobile: PropTypes.bool,
  customText: PropTypes.string,
  showBackBtn: false,
  showApplyBtn: false,
};

VstLocales.defaultProps = {
  selected: 'en',
  className: '',
  label: '',
  menuName: '',
  headerTitle: 'Language',
  customX: 0,
  customY: 0,
  vertical: 'top',
  horizontal: 'left',
  height: '400px',
  isMobile: false,
  showBackBtn: true,
  customText: '',
  showApplyBtn: true,
  headerBackButton: 'Language',
};
